import React from "react";
import { useTranslation } from "react-i18next";
import { Box, TableCell, Tooltip } from "@mui/material";
import accountBadge from "@iconify/icons-mdi/account-badge";
import accountCheck from "@iconify/icons-mdi/account-check";
import { Icon } from "@iconify/react";
import {
  useMyLeaveIsExaminerContract,
  useMyLeaveIsViewerContract,
} from "my-leave/hooks";

interface MyLeaveAvailableRolesProps {
  align?: "inherit" | "left" | "center" | "right" | "justify";
  row: {
    contract: any; // Replace 'any' with the actual type of 'contract' if known
  };
}

export const MyLeaveAvailableRoles: React.FC<MyLeaveAvailableRolesProps> = ({
  align,
  row,
}) => {
  const { t } = useTranslation();

  let { data: isExaminerContract } = useMyLeaveIsExaminerContract({
    contract: row?.contract,
  });

  let { data: isViewerContract } = useMyLeaveIsViewerContract({
    contract: row?.contract,
  });

  return (
    <TableCell align={align || "center"} style={{ padding: "0px" }}>
      <Box display="flex" flexDirection="row">
        <Tooltip title={t("MY_HR_ROLE_EXAMINER")} placement="top">
          <Box>
            {isExaminerContract && <Icon icon={accountCheck} height="24px" />}
          </Box>
        </Tooltip>
        <Tooltip title={t("MY_HR_ROLE_VIEWER")} placement="top">
          <Box>
            {isViewerContract && <Icon icon={accountBadge} height="24px" />}
          </Box>
        </Tooltip>
      </Box>
    </TableCell>
  );
};

export default MyLeaveAvailableRoles;
